import ImageUpload from '../src/ImageUpload';
export default ImageUpload;
